import { useContext, useState, useEffect } from "react";
import { UserContext } from "@ipd/js-common";
import { Permissions } from "../typescript/types/data";

const usePermissions = (permissions: Permissions | undefined): boolean => {
  const { hasClaim, token } = useContext(UserContext);
  const [hasPermissions, setHasPermissions] = useState(false);

  useEffect(() => {
    // token (from UserContext) and permissions needs to be present and defined to make the claim check.
    if (token && permissions) {
      const featuresPermissions = Object.values(permissions);
      setHasPermissions(featuresPermissions.some((perm) => hasClaim(perm, "LciClinicalPipeline")));
    }
  }, [token]);

  return hasPermissions;
};

export default usePermissions;
